window.process = {
    env: {
      NODE_ENV: 'development',
      PUBLIC_URL: '/web/'
  }
};
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
ReactDOM.render(<App />, document.getElementById('root'))
